
// Uses Composition Api-style syntax

export const useAppStore = defineStore('AppStore', () => 
{
    const router                = useRouter()  // used below
    
    // State ------------------------------------------------------------------

    const sideBarHidden         = ref(false)
    const showSideButton        = ref(false)
    const disableGlobalKeys     = ref(false)
    const showPrevNext          = useLocalStorage('showPrevNext', true)
    const showBreakpoints       = useLocalStorage('showBreakpoints', false)
    const showNotification      = useLocalStorage('showNotification', true)
    const showNewChatMessages   = useLocalStorage('showNewChatMessages', true)
    const showJsonEntities      = useLocalStorage('showJsonEntities', false)
    const persistSearch         = useLocalStorage('persistSearch', false)
    const altTheme              = useLocalStorage('altTheme', false)
    const fullWidth             = useLocalStorage('fullWidth', false)
    const infoLevel             = useLocalStorage('infoLevel', 2)
    const activeFloater         = useLocalStorage('activeFloater', '')
    const pagerDebugger         = useLocalStorage('pagerDebugger', false)
    const pagerDebuggerX        = useLocalStorage('pagerDebuggerX', 400)
    const pagerDebuggerY        = useLocalStorage('pagerDebuggerY', 30)
    const showPlatformInfo      = useLocalStorage('showPlatformInfo', false)
    const hideToolTips          = useLocalStorage('hideToolTips', true)
	
    // Getters ------------------------------------------------------------------

	const infoLevelText = computed(() =>
	{
		switch (infoLevel.value)
		{
			case 1: return "?"
			case 2: return "Info"
			case 3: return "Help"
			default: return "Info"
		}
	})

    // Actions ------------------------------------------------------------------

    async function resetLocalStorage() 
    {
        const local =  
        [   
            'showPrevNext', 'showBreakpoints', 'showNotification',
            'showNewChatMessages','showJsonEntities', 'persistSearch', 
            'altTheme', 'fullWidth', 'infoLevel', 'activeFloater', 
            'pagerDebugger', 'pagerDebuggerX', 'pagerDebuggerY', 'showPlatformInfo',
            'activeFloater', 'disableGlobalKeys','hideToolTips'
        ]

        local.forEach(item => localStorage.removeItem(item))

        const toast = useToastStore()
        toast.showInfo('Removed local App preferences')

        setTimeout(() => router.go(0), 2000)
    }

    const setInfoLevel  = (num) => 
	{
		const min = 1
	    const max = 3

        let val = infoLevel.value + num

		if(val < min)
			val = max
		else if(val > max)
			val = min

		infoLevel.value = val
	}

    // Return ------------------------------------------------------------------

    return {
        // Refs
        sideBarHidden,
        showSideButton,
        showPrevNext,
        showBreakpoints,
        showNotification,
        showNewChatMessages,
        showJsonEntities,
        persistSearch,
        altTheme,
        fullWidth,
        infoLevel,
        pagerDebugger,
        pagerDebuggerX,
        pagerDebuggerY,
        showPlatformInfo,
        activeFloater,
        disableGlobalKeys,
        hideToolTips,

        infoLevelText,

        // actions
        resetLocalStorage,
        setInfoLevel
    }
})
